<template xmlns="http://www.w3.org/1999/html">
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>

        <InputRadioGroup
            name="sexuality"
            :required="checkIsRequired('sexuality')"
            :error="formRef.errors.get('sexuality')"
            v-model="formRef.sexuality"
            v-model:other-text="formRef.other_sexuality_text"
            :options="getField('sexuality')['options']"
            @input="formRef.errors.clear('sexuality')"
            :form="formRef"
        >
            <template v-slot:question>
                {{ getField("sexuality").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            name="gender"
            :required="checkIsRequired('gender')"
            :error="formRef.errors.get('gender')"
            v-model="formRef.gender"
            v-model:other-text="formRef.other_gender_text"
            :options="getField('gender')['options']"
            @input="formRef.errors.clear('gender')"
            :form="formRef"
        >
            <template v-slot:question>
                {{ getField("gender").question }}
            </template>
        </InputRadioGroup>
    </div>
</template>

<script setup>
import InputRadioGroup from "../Form/InputRadioGroup";
import Form from "../../Form";
import { isRequired } from "./helpers";
import { ref, markRaw } from "vue";

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

let formRef = markRaw(ref(new Form({
    sexuality: null,
    other_sexuality_text: null,
    gender: null,
    other_gender_text: null
}, props.formData)))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
   var fieldData = getField(fieldName);
   return isRequired(fieldData, formRef.value);
}

defineExpose({
    formRef
})
</script>
